import * as signalR from '@microsoft/signalr';
import { eventBus } from './eventBus';

const client = {
  connection: null as any,
  init: (callback: Function) => {
    async function start() {
      try {
        await client.connection.start();
        console.log('SignalR Connected.');
        if (callback) callback();
      } catch (err) {
        console.log(err);
        setTimeout(start, 5000);
      }
    }
    if (!client.connection) {
      client.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${(window as any).vue$config.API_ENDPOINT}/hub`)
        .build();

      client.connection.onclose(start);

      // Start the connection.

      client.connection.on('Notify', (key, payload) => {
        eventBus.$emit(key, JSON.parse(payload));
      });
      start();
    }
  },
  login: (id) => {
    if (client.connection) {
      (client.connection as signalR.HubConnection).invoke('Login', id);
    }
  },
  logout: () => {
    if (client.connection) {
      (client.connection as signalR.HubConnection).invoke('Logout');
    }
  },
};

export { client };
